import QuestionObj from '../Models/QuestionObj';

const ServiceRequest_QSet = [    
    new QuestionObj({
        questionSet:{
            English: 'Can your service agents monitor and access data from your Internet of Things (IoT)-connected assets within a single application to speed issue resolution?',
            German: 'German Q1',
            French: "French Q1",
            Russian: "Russian Q1",
            Turkish: "Turkish Q1",
            Italian: "Italian Q1",
            Spanish: "Spanish Q1",
            PortugueseBR: "PortugueseBR Q1",
            SpanishLAD: "SpanishLAD Q1",
        },
        answerSet:{
            English: [
                "No, we are not capturing any IoT-connected asset data",
                "No, data captured from IoT-connected assets is not accessible by service agents",
                "Yes, service agents can access data from IoT-connected assets, but not within the customer service center",
                "Yes, service agents have seamless access to IoT-connected asset data within the customer service center",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,50,75, 100], 
    }),
    new QuestionObj({
        questionSet:{
            English: 'Are customers able to troubleshoot service issues through self-serve, automated digital tools?',
            German: 'German Q2',
            French: "French Q2",
            Russian: "Russian Q2",
            Turkish: "Turkish Q2",
            Italian: "Italian Q2",
            Spanish: "Spanish Q2",
            PortugueseBR: "PortugueseBR Q2",
            SpanishLAD: "SpanishLAD Q2",
        },
        answerSet:{
            English: [
                'No, all service issues require a live agent',
                'We offer a few automated tools, but customers often require a live agent’s help',
                'Yes, customers can troubleshoot most simple issues on their own without a live agent',
                'Yes, customers can troubleshoot nearly all simple and some complex issues without a live issue',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,50,75,100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Can you automatically create a work order and schedule a field service event based on data from IoT-enabled devices?',
            German: 'German Q3',
            French: "French Q3",
            Russian: "Russian Q3",
            Turkish: "Turkish Q3",
            Italian: "Italian Q3",
            Spanish: "Spanish Q3",
            PortugueseBR: "PortugueseBR Q3",
            SpanishLAD: "SpanishLAD Q3",
        },
        answerSet:{
            English: [
                'No, we are not capturing any IoT-connected asset data',
                'No, data captured from IoT-connected assets is not integrated with our work order management or service scheduling systems',
                'Yes, we can automatically schedule a next-day service activity based on data from IoT-connected assets',
                'Yes, we can automatically schedule a same-day service activity based on data from IoT-connected assets',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,50,75, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Do you offer customers a configurable portal to log in and get real time status and other relevant information about their assets?',
            German: 'German Q4',
            French: "French Q4",
            Russian: "Russian Q4",
            Turkish: "Turkish Q4",
            Italian: "Italian Q4",
            Spanish: "Spanish Q4",
            PortugueseBR: "PortugueseBR Q4",
            SpanishLAD: "SpanishLAD Q4",
        },
        answerSet:{
            English: [
                "No, we do not have a customer portal",
                "Yes, we have a customer portal, but no relevant asset information is available",
                "Yes, we have a customer portal with detailed asset and service history that is updated daily ",
                "Yes, we have a customer portal with detailed asset and service history that is updated in real-time",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,50,75, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Do your contact center agents have a 360-degree view of your customer, including account information, installed asset data, as well as order and service history?',
            German: 'German Q5',
            French: "French Q5",
            Russian: "Russian Q5",
            Turkish: "Turkish Q5",
            Italian: "Italian Q5",
            Spanish: "Spanish Q5",
            PortugueseBR: "PortugueseBR Q5",
            SpanishLAD: "SpanishLAD Q5",
        },
        answerSet:{
            English: [
                "No, we cannot deliver a full view of the customer to our contact center agents consistently",
                "We can deliver some of this data to our contact center agents but not consistently for every event or customer ",
                "We can usually deliver this data to our contact center agents, but accuracy can be an issue",
                "We can consistently deliver this data accurately to our contact center agents",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,50,75, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Can you automate customer notifications indicating a service disruption may occur or has already occurred?',
            German: 'German Q6',
            French: "French Q6",
            Russian: "Russian Q6",
            Turkish: "Turkish Q6",
            Italian: "Italian Q6",
            Spanish: "Spanish Q6",
            PortugueseBR: "PortugueseBR Q6",
            SpanishLAD: "SpanishLAD Q6",
        },
        answerSet:{
            English: [
                "No, customers are almost always the first to report service disruptions", 
                "No, these types of notifications require an agent to contact the customer",
                "Yes, we have an automated notification system in place, but they are not delivered in real-time and often received too late to be useful",
                "Yes, we have an automated notification system in place that sends notifications in real-time so customers can respond quickly"
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,50,75, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Do you provide AI-prescribed next-best action recommendations to your service agents during customer service engagements?',
            German: 'German Q6',
            French: "French Q6",
            Russian: "Russian Q6",
            Turkish: "Turkish Q6",
            Italian: "Italian Q6",
            Spanish: "Spanish Q6",
            PortugueseBR: "PortugueseBR Q6",
            SpanishLAD: "SpanishLAD Q6",
        },
        answerSet:{
            English: [
                "Not currently", 
                "Yes, but they often lack contextual relevance and are not reliable",
                "Yes, but our agents need more guidance and training for how to use them",
                "Yes, we deliver relevant AI-generated guidance to our agents which they regularly use",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,50,75, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Do you support SMS, chatbots, social, and other messaging channels customers prefer to use today?',
            German: 'German Q6',
            French: "French Q6",
            Russian: "Russian Q6",
            Turkish: "Turkish Q6",
            Italian: "Italian Q6",
            Spanish: "Spanish Q6",
            PortugueseBR: "PortugueseBR Q6",
            SpanishLAD: "SpanishLAD Q6",
        },
        answerSet:{
            English: [
                "No, we offer phone-based support only", 
                "No, we only support a limited range of channels, like phone and email",
                "Yes, we support most but not all messaging channels",
                "Yes, our customers can communicate on their channel of choice",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,50,75,100],
    }),
];

export default ServiceRequest_QSet;